import { render } from "./PublicContestList.vue?vue&type=template&id=b6cb5c56"
import script from "./PublicContestList.vue?vue&type=script&lang=js"
export * from "./PublicContestList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__